module.exports = __webpack_public_path__ + "static/EverForward8-f88935e0704ebb82192e1b1743199e33.webp";